/* eslint-disable react/no-unused-state */
/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Transition from 'react-transition-group/Transition';
import styles from './fieldDetail.module.scss';
import Clickable from '../../../../components/clickable/Clickable';
import checklistStyles from '../../complete/components/InspectionChecklist/checklist.module.scss';
import { renderInfoForType } from '../../../../utils/helpers';
import Modal from '../../../../components/modal/modal';
import FileSlider from '../../../../components/photoCarousel/FileSlider';

class ChecklistRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      slideModal: false,
      selectedRemark: {},
      woOpened: true
    };

    this.transitionStyles = {
      entered: {
        height: '0',
        fontSize: '0',
        opacity: '0'
      },
      exited: {
        height: '157px'
      }
    };

    this.transitionListStyles = {
      entered: {
        height: '0',
        fontSize: '0',
        opacity: '0'
      },
      exited: {
        height: 'auto'
      }
    };

    this.imageStyles = {
      entered: {
        width: '0px',
        opacity: '0'
      },
      exited: {
        width: '100px',
        opacity: '1'
      }
    };

    this.toggleRemark = this.toggleRemark.bind(this);
  }

  toggleRemark() {
    this.setState(prevState => ({
      opened: !prevState.opened,
      woOpened: true
    }));
  }

  render() {
    const {
      answer, item, remarks, rowSpan, field, isColumn, toleranceInspection, checklistAttachments, toleranceResult, answerDetails
    } = this.props;
    const {
      opened,
      slideModal
    } = this.state;
    let status = answer?.[item.key] ? 'pass' : 'fail';
    if (answer?.[item.key] === 'N/A') {
      status = 'N/A';
    }
    let allTrue = false;
    if (isColumn && answer && rowSpan) {
      const result = Object.values(answer).map(f => !Object.values(f).includes(false));
      allTrue = !result.includes(false);
    } else if (answer && rowSpan) {
      allTrue = Object.keys(answer).map(a => answer[a]).reduce((a, b) => a && b);
    }
    let dot = allTrue ? checklistStyles.success : checklistStyles.failure;
    const rspan = remarks?.length > 0 ? rowSpan + 1 : rowSpan;

    const attachments = checklistAttachments?.filter(chAttach => (
      chAttach?.attachment_id === item?.settings?.attachments?.[0]?.attachment_id
    ));

    return (
    <>
      <tr className={styles.row} key={item.key}>
        {rowSpan && (
          <td rowSpan={rspan}>
            <div style={{ display: 'flex' }}>
              <span className={`${checklistStyles.statusDot} ${dot}`} style={{ margin: '4px 20px' }} />
              <p>{field.title}</p>
            </div>
          </td>
        )}
        <td>{item.value}</td>
        {toleranceInspection && (
          <>
            <td>
              {item?.standard && (
                <>
                  {item?.operator}&nbsp;{item?.standard}&nbsp;{item?.units}
                </>
              )}
            </td>
            <td>
              {item?.standard && item?.tolerance && (
                <>
                  &plusmn;{item?.tolerance}&nbsp;{item?.units}
                </>
              )}
            </td>
          </>
        )}
        {isColumn && Object.keys(answer[item.key]).map(f => (
          <td className={(answer[item.key][f] === true || answer[item.key][f] === false) ? styles[answer[item.key][f] ? 'pass' : 'fail'] : ''}>
            {!toleranceResult?.[item.key]?.[f] && (
              <>
                {(answer[item.key]?.[f] === true || answer[item.key]?.[f] === false) ? (
                  <>
                    {field.status_options?.[answer[item.key]?.[f] ? 'pass' : 'fail']}
                  </>
                ) : (
                  <>{answer[item.key]?.[f]}</>
                )}
              </>
            )}
            {toleranceInspection && (
              <p>
                {toleranceResult?.[item.key]?.[f]}
&nbsp;
                {item?.units}
              </p>
            )}
          </td>
        ))}
        {!isColumn && (
          <td className={styles[status]}>
            {!toleranceResult?.[item.key] && (field.status_options?.[status] || answer[item.key])}
            {toleranceInspection && (
              <p>
                {toleranceResult?.[item.key]}
&nbsp;
                {!isNaN(Number(toleranceResult?.[item.key])) && item?.units}
              </p>
            )}
          </td>
        )}
        <td>
          {remarks && remarks?.length >0 && (
            <Clickable className={styles.remark}
              onClick={this.toggleRemark}><FormattedMessage id="workorders.remarks" defaultMessage="Remarks" />
            </Clickable>
          )}
        </td>
      </tr>
      {attachments?.length > 0 && (
        <tr className={styles.row} key={item.key}>
          <td>
            <Clickable onClick={() => this.setState({ slideModal: true })}>
              <img src={attachments?.[0]?.url} alt={attachments?.[0]?.file_name || ''} width="100" height="100" />
            </Clickable>
            <Modal
              showIn={slideModal}
              onClose={() => { this.setState({ slideModal: false }); }}
              contentStyles={{
                overflow: 'visible',
                background: '#E6EAEE',
                padding: '20px 40px'
              }}
            >
              <div>
                <FileSlider
                  photos={attachments}
                  initialSlide={0}
                />
              </div>
            </Modal>
          </td>
        </tr>
      )}
      {!opened && answerDetails?.re_inspection_info?.length === 0 && remarks && remarks?.map(remark => (
        <>
          <Transition in={opened} timeout={0}>
            {state => (
              <tr className={`${styles.row} ${styles.remarkRow}`}
                key={`remark-${item.key}`} style={this.transitionStyles[state]}
              >
                <td style={{ display: 'flex' }}>
                  <div style={{ display: 'flex' }}>
                    <div className={styles.remarkWrapper}>
                      {remark?.attachments?.length > 0 && remark?.attachments.map((img, idx) => (
                        <Clickable onClick={() => this.setState({ modal: true, initialSlide: idx, selectedRemark: remark })}>
                          <img style={this.imageStyles[state]} src={img.image} alt="" />
                        </Clickable>
                      ))}
                      <span className={styles.remarkText}>
                        {' '}
                        <pre>
                          {remark?.text}
                          {' '}
                        </pre>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </Transition>
        </>
      ))}
      <Transition in={opened} timeout={0}>
        {state => (
          <>
            {answerDetails?.re_inspection_info?.length > 0 && state === 'exited' && remarks?.map(remark => (
              <tr className={styles.remarkTable} style={this.transitionListStyles[state]}>
                  <td className={styles.td}>
                    <FormattedMessage
                      id="inspections.complete_inspections.date_time"
                      defaultMessage="Date & Time"
                      tagName="h1"
                    />
                    <p>
                      {remark?.info?.created_date && (
                        renderInfoForType({ type: 'datetime' }, remark?.info?.created_date, null, null)
                      )}
                    </p>
                  </td>
                  <td className={styles.td}>
                    <FormattedMessage
                      id="inspections.complete_inspections.status"
                      defaultMessage="Status"
                      tagName="h1"
                    />
                    <p>{remark?.info?.status === false ? 'Unsatisfactory' : 'Satisfactory'}</p>
                  </td>
                  <td className={styles.td}>
                    <FormattedMessage
                      id="inspections.complete_inspections.remark"
                      defaultMessage="Remark"
                      tagName="h1"
                    />
                    <p>{remark?.text}</p>
                  </td>
                  <td className={styles.td}>
                    <FormattedMessage
                      id="lease.tenants.steps.step3.attachment"
                      defaultMessage="Attachments"
                      tagName="h1"
                    />
                    <p className={styles.attachments}>
                      {remark?.attachments?.length > 0 && remark?.attachments.map((img, idx) => (
                        <Clickable onClick={() => this.setState({ modal: true, initialSlide: idx, selectedRemark: remark })}>
                          <img style={this.imageStyles[state]} src={img.image} alt="" />
                        </Clickable>
                      ))}
                    </p>
                  </td>
              </tr>
            ))}
            {answerDetails?.re_inspection_info?.length > 0 && state === 'exited' && answerDetails.re_inspection_info?.map(reInsp => (
              <>
                {reInsp?.tracking_info?.checklist_updates?.map(info => (
                  <>
                    {info?.field === field?.id && info?.item === item.key && (
                      <tr className={styles.remarkTable} style={this.transitionListStyles[state]}>
                        <td className={styles.td}>
                          <FormattedMessage
                            id="inspections.complete_inspections.date_time"
                            defaultMessage="Date & Time"
                            tagName="h1"
                          />
                          <p>
                            {reInsp?.re_inspection_date && (
                              renderInfoForType({ type: 'datetime' }, reInsp?.re_inspection_date, null, null)
                            )}
                          </p>
                        </td>
                        <td className={styles.td}>
                          <FormattedMessage
                            id="inspections.complete_inspections.status"
                            defaultMessage="Status"
                            tagName="h1"
                          />
                          <p>{info?.value === 'False' ? 'Unsatisfactory' : 'Satisfactory'}</p>
                        </td>
                        <td className={styles.td}>
                          <FormattedMessage
                            id="inspections.complete_inspections.remark"
                            defaultMessage="Remark"
                            tagName="h1"
                          />
                        </td>
                        <td className={styles.td}>
                          <FormattedMessage
                            id="lease.tenants.steps.step3.attachment"
                            defaultMessage="Attachments"
                            tagName="h1"
                          />
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </>
            ))}
          </>
        )}
      </Transition>
    </>);
  }
}
ChecklistRow.propTypes = {
  field: PropTypes.shape({}).isRequired,
  answer: PropTypes.shape({}).isRequired,
  remark: PropTypes.shape({}),
  rowSpan: PropTypes.number,
  item: PropTypes.shape({}).isRequired,
  workorders: PropTypes.arrayOf(PropTypes.shape({}))
};

ChecklistRow.defaultProps = {
  rowSpan: undefined,
  remark: undefined,
  workorders: []
};

export default ChecklistRow;
